import UserRepository from "./repositories/UserRepository";
import TagRepository from "./repositories/TagRepository";
import PlanRepository from "./repositories/PlanRepository";
import ProposalRepository from "./repositories/ProposalRepository";
import CompanyRepository from "./repositories/CompanyRepository";
import BusinessRepository from "./repositories/BusinessRepository";
import CategoryRepository from "./repositories/CategoryRepository";
import MetaGroupRepository from "./repositories/MetaGroupRepository";
import MetaRepository from "./repositories/MetaRepository";
import TypeRepository from "./repositories/TypeRepository";
import CalendarRepository from "./repositories/CalendarRepository";
import TemplateRepository from '~/api/admin/repositories/TemplateRepository';
import DocumentTemplateRepository from "@/api/admin/repositories/DocumentTemplateRepository";
import ProvinceRepository from "@/api/admin/repositories/ProvinceRepository";
import ContactRepository from "@/api/admin/repositories/ContactRepository";
import ContactMemoRepository from "@/api/admin/repositories/ContactMemoRepository";
import AppTagRepository from "@/api/admin/repositories/AppTagRepository";
import ApplicationRepository from "@/api/admin/repositories/ApplicationRepository";
import MstFieldRepository from "@/api/admin/repositories/MstFieldRepository";
import AppCategoryRepository from "~/api/admin/repositories/AppCategoryRepository";
import LandingRepository from "~/api/admin/repositories/LandingRepository";
import WorkRepository from "~/api/admin/repositories/WorkRepository";
import RequestEbookRepository from "~/api/admin/repositories/RequestEbookRepository";
import PaperRepository from "~/api/admin/repositories/PaperRepository";
import ToolRepository from "~/api/admin/repositories/ToolRepository";
import EditorFileUploadRepository from "./repositories/EditorFileUploadRepository";
import TransactionRepository from "./repositories/TransactionRepository";
import AppCampaignRepository from "./repositories/AppCampaignRepository";

export default ($axios) => ({
  users: UserRepository($axios),
  tags: TagRepository($axios),
  plans: PlanRepository($axios),
  proposals: ProposalRepository($axios),
  companies: CompanyRepository($axios),
  businesses: BusinessRepository($axios),
  categories: CategoryRepository($axios),
  metaGroups: MetaGroupRepository($axios),
  metas: MetaRepository($axios),
  types: TypeRepository($axios),
  calendar: CalendarRepository($axios),
  template: TemplateRepository($axios),
  documentTemplates: DocumentTemplateRepository($axios),
  provinces: ProvinceRepository($axios),
  contacts: ContactRepository($axios),
  contactMemos: ContactMemoRepository($axios),
  appTags: AppTagRepository($axios),
  appCategories: AppCategoryRepository($axios),
  applications: ApplicationRepository($axios),
  mstFields: MstFieldRepository($axios),
  landing: LandingRepository($axios),
  work: WorkRepository($axios),
  requestEbooks: RequestEbookRepository($axios),
  papers: PaperRepository($axios),
  tool: ToolRepository($axios),
  editor: EditorFileUploadRepository($axios),
  transactions: TransactionRepository($axios),
  applicationUsers: TransactionRepository($axios),
  appUserCampaigns: AppCampaignRepository($axios)
});
